import { render, staticRenderFns } from "./UnitsMeasure.vue?vue&type=template&id=65cdfc90"
import script from "./UnitsMeasure.vue?vue&type=script&lang=js"
export * from "./UnitsMeasure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports